Vue.asyncComponent('ak-html', {
    name:'ak-html',
    props: {
        html: {
            type: String,
        }
    },
    computed: {
        currentHtml() {
            if (this.html) {
                return this.html;
            }

            return this.$slots.default.length ?
                this.$slots.default[0].text :
                null
        }
    }
}, 'layout/ak-html.html');